import React from 'react'
import './section-main-banner.scss'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import { graphql, useStaticQuery } from 'gatsby'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'

import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const SectionMainBanner = () => {
  const isMobile = useMediaQuery()

  const { allContentfulVConfidentHome } = useStaticQuery(
    graphql`
      query BannerHome {
        allContentfulVConfidentHome {
          nodes {
            node_locale
            paisesDeRestriccion
            bannerPrincipal {
              banner {
                gatsbyImageData(quality: 100)
              }
              titulo
              redireccion
              tieneLinkExterno
            }
          }
        }
      }
    `
  )

  const banners = allContentfulVConfidentHome.nodes.filter(
    e =>
      e.node_locale === 'es-CO' &&
      !e.paisesDeRestriccion?.includes(process.env.LOCALE)
  )[0].bannerPrincipal

  const options = {
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
    dots: true,
    centerMode: false,
    dotsClass: 'f-slick-dots-banner',
  }

  const dataLayerBanner = (redirect, title) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Banners_VConfident',
      category: 'banner_principal',
      action: 'click',
      label: redirect,
      banner_name: title,
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  return (
    <section className="f-section-main-banner">
      <Slider {...options}>
        {banners.map((image, index) => {
          return (
            <a
              onClick={e => {
                e.preventDefault()
                dataLayerBanner(image.redireccion ,image.titulo)
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'ga_event',
                  category: 'V-Confident :: Home',
                  action: 'Click :: Banner',
                  label: image.titulo,
                  value: '',
                })
                window.open(
                  image.redireccion,
                  image.tieneLinkExterno ? '_blank' : '_self'
                )
              }}
              className="f-slide-container"
              href={image.redireccion}
              key={`banner-${index + 1}`}
            >
              <GatsbyImage
                className="f-slide-container__image"
                image={getImage(image.banner[isMobile ? 1 : 0])}
                alt="Banner"
                loading='eager'
              />
            </a>
          )
        })}
      </Slider>
    </section>
  )
}

export default SectionMainBanner
